import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, loadScrollMagic } from "../../utils/siteUtils";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import Swiper from 'swiper';
import gsap from 'gsap';
import { gtag } from "../../utils";
const RepeatedRotation = props => {
	const { lang, rendering, fields, page } = props;
  const { list, duration, paddingAboveTop } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const swiperEl = useRef(null)
  const swiper = useRef(null)
  const rootNode = useRef()
  const [startX, setStartX] = useState(null)
  const pctitleEl = useRef()
  const pcdescEl = useRef()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isStart, setIsStart] = useState(true)
  const [marginTop, setMarginTop] = useState(0)
  const timer = useRef()

  const changeSlide = (e, index) => {
  	gtag('event', 'Component_info', {
      'component_name': 'RepeatedRotation',
      'page_title': page?.name
    });
  	setCurrentIndex(index)
  }

  const buildSwiper = () => {
    const options = {
    	loop: true,
      watchSlidesProgress: true,
      slidesPerView: 1,
      spaceBetween: 40,
      autoplay: {
      	delay: duration.value * 1000
      },
      on: {
        slideChange(swiper) {
          let realIndex = swiper.realIndex
          setCurrentIndex(realIndex)
        }
      }
    }
    swiper.current = new Swiper(swiperEl.current, options);
  }

  const touchStart = (e) => {
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    setStartX(eventX)
    clearInterval(timer.current)
  }

  const touchEnd = (e) => {
    const endX = e.clientX || (e.touches && e.touches[0]?.clientX) || e.changedTouches[0].pageX || 0
    let i = currentIndex
    if(endX - startX < -50) { //切换到下一个
      if(isAR) {
        if(i > 0) {
	  			i--
	  		} else {
	  			i=list.length-1
	  		}
	  		setCurrentIndex(i)
      } else {
    		if(i < list.length - 1) {
	  			i++
	  		} else {
	  			i=0
	  		}
	  		setCurrentIndex(i)
      }
    } else if(endX - startX > 50) { //切换到上一个
      if(isAR) {
        if(i < list.length - 1) {
	  			i++
	  		} else {
	  			i=0
	  		}
	  		setCurrentIndex(i)
      } else {
      	if(i > 0) {
	  			i--
	  		} else {
	  			i=list.length-1
	  		}
	  		setCurrentIndex(i)
      }
    }
    clearInterval(timer.current) // 拖拽时停止自动轮播
    setTimeout(v => {
    	if(duration.value && duration.value !== 0 && !isMobile) {
	  		autoplay()
	  	}
    }, 10)
  }

  const autoplay = () => {
  	let i = currentIndex
  	timer.current = setInterval(v => {
  		if(i < list.length - 1) {
  			i++
  		} else {
  			i=0
  		}
  		setCurrentIndex(i)
  	}, duration.value * 1000)
  }

  const mouseOver = (e, index) => {
  	setCurrentIndex(index)
  	clearInterval(timer.current) // 鼠标移上去停止自动轮播
  }

  const mouseLeave = () => {
  	if(duration.value && duration.value !== 0 && !isMobile) {
  		autoplay()
  	}
  }

  const onScroll = () => {
  	setMarginTop(rootNode?.current?.getBoundingClientRect()?.top)
  }

  useEffect(() => {
  	if(duration.value && duration.value !== 0 && isStart && marginTop !== 0 && marginTop < 200 && !isMobile) {
  		setIsStart(false)
			clearInterval(timer.current)
  		autoplay()
  	} else if(duration.value && duration.value !== 0 && isStart && marginTop !== 0 && marginTop < 200 && isMobile && swiper.current) {
  		swiper.current.autoplay.start()
  	}
  }, [marginTop])

  useEffect(() => {
  	setTimeout(v => {
  		if(isMobile) {
  			buildSwiper()
  			if(swiper.current) {
  				swiper.current.autoplay.stop()
  			}
  		}
  	}, 100)
  	window.addEventListener("scroll", onScroll)
  	setTimeout(v => {
	  	let ScrollMagic, controller, scene, tl
			ScrollMagic = loadScrollMagic()
			controller = new ScrollMagic.Controller()
			tl = gsap.timeline()

			if(isMobile) {
				for (let i = 0; i < list.length; i++) {
					tl.add(gsap.to(`#item__title${list[i].id}`, {
						y: 0,
						opacity: 1
					}),1)
					.add(gsap.to(`#item__desc${list[i].id}`, {
						y: 0,
						opacity: 1
					}),1)
				}
			}

			for (let i = 0; i < list.length; i++) {
				tl.add(gsap.to(`#item__bullet${list[i].id}`, {
					width: isMobile ? '20px' : '288px'
				}),1)
			}
			
			tl.add(gsap.to(pctitleEl.current,{
			  y: 0,
			  opacity: 1
			}, 1))
			.add(gsap.to(pcdescEl.current,{
			  y: 0,
			  opacity: 1
			}, 1))
			
			scene = new ScrollMagic.Scene({
			  triggerElement: rootNode.current,
			  triggerHook: 0,
			  offset: - window.innerHeight / 1.2,
			  duration: window.innerHeight * 0.6
			})
			.setTween(tl)
			.addTo(controller)

			return () => {
				scene.destroy(true);
				scene = null;
				controller.destroy(true);
				controller = null;
			};
  	}, 200)
  	return () => {
  		window.removeEventListener("scroll", onScroll)
  	}
  }, [])

  const rootClasses = classNames("c-repeated-rotation", getOverallSettingsClasses(fields));
  const mSwiperClass = classNames("c-repeated-rotation__m_swiper", `top-${paddingAboveTop?.fields?.key.value}`)
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}  ref={rootNode} onMouseDown={touchStart} onMouseUp={touchEnd}>
      <div className="c-repeated-rotation__swiper">
      	<div className="swiper-wrapper">
      		{list && list.map((item, index) => (
      			<div className={["swiper-slide", index === currentIndex ? 'active' : ''].join(' ')} key={index}>
      				{!isMobile && <div style={{ backgroundImage: `url(${item?.fields?.pc_image?.value?.src})` }} className="image" />}
      				{isMobile && <div style={{ backgroundImage: `url(${item?.fields?.m_image?.value?.src})` }} className="image" />}
      				<div className="text-content">
      					{!isMobile && <RichText tag="div" className="title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
      					{!isMobile && <RichText tag="div" className="desc" field={item?.fields?.pc_desc} id={`item__desc${item.id}`} />}
      					{isMobile && <RichText tag="div" className="title" field={item?.fields?.m_title} id={`item__title${item.id}`} />}
      					{isMobile && <RichText tag="div" className="desc" field={item?.fields?.m_desc} id={`item__desc${item.id}`} />}
      				</div>
      			</div>
      		))}
      	</div>

      	<div className="pagination-content">
	      	<div className="title-content" ref={pctitleEl}>
	      		{list && list.map((item, index) => (
	      			<div className={["pc-title", currentIndex === index ? 'active' : ''].join(' ')} key={index} onMouseOver={(e) => {mouseOver(e, index)}} onMouseLeave={mouseLeave}>
	      				<RichText tag="div" field={item?.fields?.pc_title} />
	      			</div>
	      		))}
	      	</div>
	      	{((list?.length > 1 && isMobile) || !isMobile) && <div className="swiper-pagination">
	      		{list.map((item, index) => (
	      			<span className={["swiper-pagination-bullet", currentIndex === index ? 'swiper-pagination-bullet-active' : ''].join(' ')} key={index} onClick={(e) =>changeSlide(e, index)}>
	      				<span className="bullet-color" id={`item__bullet${item.id}`}></span>
	      			</span>
	      		))}
	      	</div>}
	      	<div className="pc-desc" ref={pcdescEl}>
	      		<RichText tag="div" className="desc" field={list[currentIndex]?.fields?.pc_desc} />
	      	</div>
	      </div>
      </div>

      <div className={mSwiperClass} ref={swiperEl}>
      	<div className="swiper-wrapper">
      		{list && list.map((item, index) => (
      			<div className={["swiper-slide", index === currentIndex ? 'active' : ''].join(' ')} key={index}>
      				 
      			</div>
      		))}
      	</div>
      </div>
    </div>
  );
};

export default 	RepeatedRotation;